import "./appMenu.scss";

import PropTypes from "prop-types";
import React from "react";

import AppMenuItem from "./AppMenuItem";

class AppMenuView extends React.Component {
  constructor(props) {
    super(props);

    this.state = { showSubMenuIndex: -1 };

    this.onToggleMenu = this.onToggleMenu.bind(this);

    this._timer = null;
  }

  componentWillUnmount() {
    if (this._timer) {
      window.clearTimeout(this._timer);
      this._timer = null;
    }
  }

  onToggleMenu(index) {
    // The delay is for the first time clicking on the menu item.
    // Waiting for the menu active flag is set
    this._timer = window.setTimeout(() => {
      const newIndex = this.props.canShowSubMenu ? index : -1;
      if (newIndex !== this.state.showSubMenuIndex) {
        this.setState({ showSubMenuIndex: newIndex });
      }
      this._timer = null;
    }, 10);
  }

  render() {
    const childItems = this.props.menuItems
      .map((item, index) => (
        <AppMenuItem
          key={item.messageType + item.value}
          itemIndex={index}
          {...item.toObject()}
          depth={this.props.depth}
          onItemClick={this.props.onItemClick}
          onToggleMenu={this.onToggleMenu}
          showOnHover={this.props.canShowSubMenu}
          showSubMenu={
            item.children &&
            item.children.size > 0 &&
            this.props.canShowSubMenu &&
            this.state.showSubMenuIndex === index
          }
        />
      ))
      .toArray();
    return <div className="appMenu">{childItems}</div>;
  }
}

AppMenuView.propTypes = {
  depth: PropTypes.number.isRequired,
  menuItems: PropTypes.object.isRequired,
  onItemClick: PropTypes.func,
  canShowSubMenu: PropTypes.bool.isRequired
};

export default AppMenuView;
